var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { isNotNullOrEmpty } from '@pcty/utils';
import { CompleteBar, InformationalBar, WarningBar } from '../ProgressBar.styled';
import { colorTypes, colorLabelTypes } from '../../styles/citron';
export var renderSection = function (renderProp, Component, automation, defaultContent) {
    if (defaultContent === void 0) { defaultContent = undefined; }
    var content = defaultContent;
    if (renderProp) {
        var jsx = renderProp();
        if (jsx) {
            content = jsx;
        }
        else {
            return undefined;
        }
    }
    return content ? React.createElement(Component, __assign({}, automation), content) : undefined;
};
export var getBarComponent = function (progress, warning) {
    if (warning) {
        return WarningBar;
    }
    if (progress >= 100) {
        return CompleteBar;
    }
    return InformationalBar;
};
export var getProgress = function (progress) {
    if (progress < 0) {
        return 0;
    }
    else if (progress > 100) {
        return 100;
    }
    return progress;
};
export var getSegmentColor = function (color, isCitron) {
    var colors = new Map([
        ['blue', '#41a8d2'],
        ['yellow', '#ffd70b'],
        ['green', '#3dc270'],
        ['red', '#d43046'],
        ['purple', '#5e4982'],
        ['orange', '#ff8800'],
        ['orange-light', '#f8b100'],
        ['blue-dark', '#11779c'],
        ['green-light', '#53d168'],
        ['lime', '#d1eb58'],
        ['purple-light', '#a95998'],
        ['pink', '#f59299'],
    ]);
    var colorsCitron = new Map([
        ['blue', colorTypes.blue],
        ['yellow', colorTypes.yellow],
        ['green', colorTypes.green],
        ['red', colorTypes.red],
        ['purple', colorTypes.purple],
        ['orange', colorTypes.orange],
        ['orange-light', colorTypes.orangeLighter],
        ['blue-dark', colorTypes.blueDark],
        ['green-light', colorTypes.greenLighter],
        ['lime', colorTypes.greenLighter],
        ['purple-light', colorTypes.purpleLighter],
        ['pink', colorTypes.pink],
    ]);
    var trendColor = getTrendColor(color, isCitron);
    if (isNotNullOrEmpty(trendColor) && color !== trendColor)
        return trendColor;
    var presetColor = (isCitron ? colorsCitron.get(color) : colors.get(color));
    if (isNotNullOrEmpty(presetColor))
        return presetColor;
    return color;
};
export var getTrendColor = function (color, isCitron) {
    var colors = new Map([
        ['positive', '#3dc270'],
        ['negative', '#c8102e'],
        ['neutral', '#75828c'],
    ]);
    var colorsCitron = new Map([
        ['positive', colorTypes.positive],
        ['negative', colorTypes.negative],
        ['neutral', colorTypes.neutral],
    ]);
    var presetColor = (isCitron ? colorsCitron.get(color) : colors.get(color));
    if (isNotNullOrEmpty(presetColor))
        return presetColor;
    return color;
};
export var getSegmentLabelColor = function (color, isCitron) {
    var colors = new Map([
        ['blue', '#41a8d2'],
        ['yellow', '#ffd70b'],
        ['green', '#3dc270'],
        ['red', '#d43046'],
        ['purple', '#5e4982'],
        ['orange', '#ff8800'],
        ['orange-light', '#f8b100'],
        ['blue-dark', '#11779c'],
        ['green-light', '#53d168'],
        ['lime', '#d1eb58'],
        ['purple-light', '#a95998'],
        ['pink', '#f59299'],
    ]);
    var colorsCitron = new Map([
        ['blue', colorLabelTypes.blue],
        ['yellow', colorLabelTypes.yellow],
        ['green', colorLabelTypes.green],
        ['red', colorLabelTypes.red],
        ['purple', colorLabelTypes.purple],
        ['orange', colorLabelTypes.orange],
        ['orange-light', colorLabelTypes.orangeLighter],
        ['blue-dark', colorLabelTypes.blueDark],
        ['green-light', colorLabelTypes.greenLighter],
        ['lime', colorLabelTypes.greenLighter],
        ['purple-light', colorLabelTypes.purpleLighter],
        ['pink', colorLabelTypes.pink],
    ]);
    var trendColor = getTrendLabelColor(color, isCitron);
    if (isNotNullOrEmpty(trendColor) && color !== trendColor)
        return trendColor;
    var presetColor = (isCitron ? colorsCitron.get(color) : colors.get(color));
    if (isNotNullOrEmpty(presetColor))
        return presetColor;
    return color;
};
export var getTrendLabelColor = function (color, isCitron) {
    var colors = new Map([
        ['positive', '#3dc270'],
        ['negative', '#c8102e'],
        ['neutral', '#75828c'],
    ]);
    var colorsCitron = new Map([
        ['positive', colorLabelTypes.positive],
        ['negative', colorLabelTypes.negative],
        ['neutral', colorLabelTypes.neutral],
    ]);
    var presetColor = (isCitron ? colorsCitron.get(color) : colors.get(color));
    if (isNotNullOrEmpty(presetColor))
        return presetColor;
    return color;
};
